import React from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { Login } from "../auth";
import { RoutesPath } from "../../constants";
import Dashboard from "../dashboard/Dashboard";
import ProfilePage from "../dashboard/ProfilePage";
import ManageScreen from "../dashboard/ManageScreen";
import SendPage from "../dashboard/SendPage";
import { OktaAuth } from "@okta/okta-auth-js";
import PropTypes from "prop-types";
import { Security, LoginCallback } from "@okta/okta-react";
import { ToastContainer } from "react-toastify";
import Loader from "../../loader/LoaderFile";
import { UnAuthenticatedRoutes, AuthenticatedRoutes } from "../../utils";
import PageOut from "../error/PageOut";
import Inactive from "../error/Inactive";

const REACT_APP_OKTA_ISSUER_ID = process.env.REACT_APP_OKTA_ISSUER_ID;
const REACT_APP_OKTA_CLINT_ID = process.env.REACT_APP_OKTA_CLINT_ID;
const REACT_APP_CALL_BACK_URL = process.env.REACT_APP_CALL_BACK_URL;

const oktaAuth = new OktaAuth({
  issuer: REACT_APP_OKTA_ISSUER_ID,
  clientId: REACT_APP_OKTA_CLINT_ID,
  redirectUri: window.location.origin + REACT_APP_CALL_BACK_URL,
  scopes: ["openid", "email", "profile", "phone", "address"],
});

const OktaSecurityWrapper = ({ children }) => {
  const navigate = useNavigate();

  // const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  //   const path = originalUri || RoutesPath.DASHBOARD;
  //   console.log(" Okta restoring:", path);
  //   navigate(path, { replace: true });
  // };

  const restoreOriginalUri = async () => {
    navigate(RoutesPath.DASHBOARD, { replace: true });
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
};

OktaSecurityWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

const Site = () => {
  return (
    <BrowserRouter>
      <ToastContainer />
      <OktaSecurityWrapper>
        <Loader />
        <Routes>
          <Route path={RoutesPath.LOGIN} element={<Login />} />

          <Route path="/login/callback" element={<LoginCallback />} />

          <Route element={<UnAuthenticatedRoutes />}>
            <Route path={RoutesPath.PARKING_ORBIT} element={<PageOut />} />
            <Route path={RoutesPath.INACTIVE_USER} element={<Inactive />} />
          </Route>

          <Route element={<AuthenticatedRoutes />}>
            <Route path={RoutesPath.DASHBOARD} element={<Dashboard />} />
            <Route path={RoutesPath.PROFILE} element={<ProfilePage />} />
            <Route path={RoutesPath.MANAGEPAGE} element={<ManageScreen />} />
            <Route path={RoutesPath.SENDPAGE} element={<SendPage />} />
          </Route>

          <Route path="*" element={<PageOut />} />
        </Routes>
      </OktaSecurityWrapper>
    </BrowserRouter>
  );
};

export default Site;